// extracted by mini-css-extract-plugin
export default {"button":"UpdatePeriodReportButton_button__dsGkR","spinner":"UpdatePeriodReportButton_spinner__rzfWi"};